var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturncup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 552 419.4",
    style: {
      enableBackground: "new 0 0 552 419.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338,0.4l-172-1c-8.3,0-15.8,8.8-15.8,17.5c0,10.6,7.5,18.4,15.8,18.4h17c0,0.6-0.2,1.1-0.2,1.7l30.6,335 c3.4,27,24.9,47.4,50.9,47.4h173.5c26,0,47.5-20.4,50-47.4l30.6-335c-0.8-1.6-0.1-1.1-0.1-1.7h16.9c9.2,0,16.8-7.9,16.8-17.5 c-1-9.6-7.6-18.4-17.7-18.4L338,0.4 M484.9,35.3l-8,87.6c-49.1,1.4-96.7,28.9-130.9,76.6c-29.2,40.5-67.5,62.8-107.8,62.8l-21-227 C217.2,35.3,484.9,35.3,484.9,35.3z M454.5,368.7c-0.8,9.1-8,15.8-16.6,15.8H264.3c-8.7,0-15.8-6.8-16.7-15.8l-6.5-71.7 c49.4-1.1,96.4-28.7,131.7-76.6c27.5-38.2,63.1-60,100.9-62.4L454.5,368.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.6,337L6.1,238.5C4,236.4,3,233.6,3,230.8c0-2.8,1-5.6,3.1-7.7l94.5-98.5c4.1-4.3,10.7-4.3,14.8,0 c4.1,4.3,4.1,11.2,0,15.5L38.8,220h122.6c5.8,0,9.5,4.9,9.5,11s-4.4,10.9-10.2,10.9h-122l76.6,79.9c4.1,4.3,4.1,11.2,0,15.5 S104.7,341.4,100.6,337z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturncup);
export default __webpack_public_path__ + "static/media/returncup.1725d240b0cbe2569f14e311ead6f7ed.svg";
export { ForwardRef as ReactComponent };